export const BBVA_OFFER_INIT_RESPONSE = 'BBVA_OFFER_INIT_RESPONSE';
export const SET_BBVA_PROPERTY = 'SET_BBVA_PROPERTY';
export const SET_BBVA_ACCOUNTS = 'SET_BBVA_ACCOUNTS';
export const BBVA_LOAN_PRE_APPROVED = 'BBVA_LOAN_PRE_APPROVED';
export const BBVA_CUSTOMER_ME_FULL = 'BBVA_CUSTOMER_ME_FULL';
export const BBVA_CUSTOMER_GLOBAL_POSITION = 'BBVA_CUSTOMER_GLOBAL_POSITION';
export const BBVA_THREE_LEG_AUTHENTICATION = 'BBVA_THREE_LEG_AUTHENTICATION';
export const BBVA_OFFER_INIT_RESPONSE_SUMMARY = 'BBVA_OFFER_INIT_RESPONSE_SUMMARY';
export const BBVA_AUTHENTICATION_FOR_SUMMARY = 'BBVA_AUTHENTICATION_FOR_SUMMARY';
export const BBVA_OFFER_INIT_RESPONSE_CONFIRM = 'BBVA_OFFER_INIT_RESPONSE_CONFIRM';
export const BBVA_AUTHENTICATION_FOR_CONFIRM = 'BBVA_AUTHENTICATION_FOR_CONFIRM';
export const BBVA_LOGIN = 'BBVA_LOGIN';
